export const NEWS = {
    GET_NEWS: 'GET_NEWS',
    SET_NEWS: 'SET_NEWS',
};

